import type { AiBuilderChatState } from '../store/types';
import type {
  AiBuilderDifficultyHint,
  AiBuilderQuizTypeHint,
} from '../utils/types';

export const AI_BUILDER_CHAT_PLACEHOLDER = {
  default: 'default',
  softChoice: 'softChoice',
  closedAction: 'closedAction',
  file: 'file',
  youtube: 'youtube',
  website: 'website',
} as const;

export type AiBuilderChatPlaceholder =
  (typeof AI_BUILDER_CHAT_PLACEHOLDER)[keyof typeof AI_BUILDER_CHAT_PLACEHOLDER];

/**
 * 컴포저 "자세히 보기" 가이드 링크 fallback — 로케일이 stale 해서
 * learnMoreUrl 키가 원문 그대로 내려오면 상대경로 이동으로 깨지므로 방어한다.
 */
export const AI_BUILDER_GUIDE_FALLBACK_URL =
  'https://docs.channel.io/zepquiz/ko/articles/AI%EB%A1%9C-%EB%AC%B8%EC%A0%9C-%EC%B6%94%EA%B0%80-548d662c';

export const AI_BUILDER_PDF_MAX_SELECTED_PAGES = 10;
export const AI_BUILDER_PDF_MAX_TOTAL_PAGES = 100;

export const initialAiBuilderChatState: AiBuilderChatState = {
  panelOpen: false,
  conversationEntryIntent: null,
  conversationQuestionState: null,
  draft: '',
  placeholder: AI_BUILDER_CHAT_PLACEHOLDER.default,
  selectedFile: null,
  selectedQuizContext: null,
  pendingQuestionSet: null,
  sessionId: null,
  usage: null,
  sourceRefs: [],
  messages: [],
  isGenerating: false,
  turnInProgress: false,
};

export const initialAiBuilderComposerSignalState = {
  focusRequestId: 0,
  filePickerRequestId: 0,
  confirmActionAttentionRequestId: 0,
  confirmActionAttentionMessageId: null as string | null,
};

/**
 * 서버 question 이벤트의 missing_slot — 이 슬롯들은 선지 label 에 canonical id
 * 를 실어 보내고, 표시 라벨과 회신 해석을 FE 가 소유한다. 렌더(카피 조회)와
 * 회신(turn hint 생성) 두 경로가 같은 문자열을 봐야 하므로 여기서 한 번만
 * 정의한다 — 어긋나면 라벨은 지역화됐는데 회신은 안 잡히는 반쪽 상태가 된다.
 */
export const AI_BUILDER_MISSING_SLOT = {
  quizTypes: 'quiz_types',
  count: 'count',
  worksheetImport: 'worksheet_import',
} as const;

export const QUIZ_TYPE_HINT_BY_CHOICE_LABEL: Record<
  string,
  AiBuilderQuizTypeHint
> = {
  OX: 'ox',
  'OX 문제': 'ox',
  '선택형 문제': 'multiple',
  '단답형 문제': 'subjective',
  '서술형 문제': 'essay',
};

export const DIFFICULTY_HINT_BY_CHOICE_LABEL: Record<
  string,
  AiBuilderDifficultyHint
> = {
  쉬움: 1,
  보통: 2,
  어려움: 3,
};
